"use strict";

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _themeSections = require("@shopify/theme-sections");

require("../sections/product");

var _swiper = require("swiper");

var _swiper2 = _interopRequireDefault(_swiper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _themeSections.load)("*");

var _productSlider = new _swiper2.default(".product-image-slider", {
  // autoplay: {
  //   delay: 500,
  // },
  slidesPerView: 1.5,
  spaceBetween: 10,
  centeredSlides: true,
  slideToClickedSlide: true,
  // navigation: {
  //   nextEl: '.swiper-button-next',
  //   prevEl: '.swiper-button-prev',
  // },
  loop: true,
  loopAdditionalSlides: 2,
  loopedSlides: 2,
  watchOverflow: true
  // pagination: {
  //   el: '.swiper-pagination',
  //   type: 'bullets',
  //   clickable: true,
  // },
});

var productTabsBtns = document.querySelectorAll(".product-tabs__btn");
var productTabsContent = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll(".product-tabs__item")));

function changeActiveTab(event) {
  var activeBtn = event.target;
  var tab = activeBtn.dataset.tab;


  if (!tab) return;

  var contentToShow = productTabsContent.find(function (tabContent) {
    return tabContent.dataset.tab == tab;
  });

  productTabsBtns.forEach(function (item) {
    return item.classList.remove("active");
  });
  productTabsContent.forEach(function (item) {
    return item.classList.remove("active");
  });
  contentToShow.classList.add("active");
  activeBtn.classList.add("active");
}

productTabsBtns.forEach(function (btn) {
  return addEventListener("click", changeActiveTab);
});